import Metadata from '../components/Metadata'

interface OpenRouteProps {
  element?: any
}

const OpenRoute = ({ element: Element }: OpenRouteProps) => {
  const defaultMetadata = {
    title: 'Safelto - Modern Estate Management Platform',
    description: 'Safelto is a modern estate management platform that provides secure, efficient, and user-friendly solutions for managing residential communities, guest access, and property management.',
    keywords: ['estate management', 'property management', 'residential community', 'guest access', 'security', 'maintenance services'],
    image: '/assets/images/safelto-big.png',
    url: 'https://safelto.com',
    type: 'website' as 'website'
  }

  return (
    <>
      <Metadata {...defaultMetadata} />
      <Element />
    </>
  )
}

export default OpenRoute
